import { send_request } from '../../utils/Request';

function cleanFilters(filters = {}) {
  return Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );
}

function dataOrThrow(response) {
  if (response?.response) throw response;
  return response?.data ?? response ?? null;
}

function idempotencyKey() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `artifact-inbox-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export async function listArtifactInbox(filters = {}) {
  return dataOrThrow(
    await send_request('project-service/artifacts/inbox', '', cleanFilters(filters), 'GET')
  );
}

export async function getArtifactInboxItem(artifactInstanceId) {
  return dataOrThrow(
    await send_request(`project-service/artifacts/${artifactInstanceId}`, '', {}, 'GET')
  );
}

export async function submitArtifactInboxEvent(artifactInstanceId, eventName, payload) {
  return dataOrThrow(
    await send_request(
      `project-service/artifacts/${artifactInstanceId}/events/${eventName}`,
      {
        payload,
        idempotencyKey: idempotencyKey(),
      },
      {},
      'POST'
    )
  );
}

export async function createArtifactInboxShareLink(artifactInstanceId) {
  return dataOrThrow(
    await send_request(`project-service/artifacts/${artifactInstanceId}/share-link`, {}, {}, 'POST')
  );
}
